import { type AgentSessionResponse } from '@air/server-sdk';

import { isWorkspaceAgentSessionNeedsAttention } from '~/components/v2/components/workspace/workspace-agent-panel/utils/isWorkspaceAgentSessionNeedsAttention';

/** Whether a session row from the list API can be archived (server-known state only). */
export const isWorkspaceAgentSessionArchivableFromList = (session: AgentSessionResponse): boolean =>
  session.status === 'idle' && !isWorkspaceAgentSessionNeedsAttention(session);
